const namespace = "options";

export const options = `${namespace}_list`;
export const options_category = `${namespace}_category_list`;
export const options_category_select = `${namespace}_category_select`;
export const optionsSelect = `${namespace}_select`;
export const optionsSelectData = `${namespace}_select_data`;
